import React, { Component } from 'react';
import './SolicitudDetailCliente.css';
import MyButton from '../../../utils/MyButton';
import {FaArrowCircleLeft,FaPlus,FaSignInAlt} from "react-icons/fa";
import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import dayjs from 'dayjs'; 
import relativeTime from 'dayjs/plugin/relativeTime'; 

import {getSolicitudCompra,clearErrors} from '../../../redux/actions/dataasistencialactions';

export class SolicitudDetailCliente extends Component {
    componentDidMount(){
        this.props.getSolicitudCompra(this.props.match.params.solicitudid);
       }

 render() {
  const { solicitud, loadingdataasistencial } = this.props.dataAsistencial;
  dayjs.extend(relativeTime);

  const credentials = solicitud?.credentials || {};

  let cargarSolicitud = !loadingdataasistencial && credentials ? (
    <div className="card-equipo">
      <div className="div-informacion-market">
        <div className="div-infocontainer-market">
          <div className="div-titulocliente">
            <h3 className="text-titulo-cliente">{credentials.titulo || 'Sin título'}</h3>
          </div>

          <div className="div-equipo-info-market">
            <div className="div-perfil-info">
              <hr className="clientes_separator" />
              {[
                ['Estado', credentials.estado],
                ['Fecha de Solicitud', credentials.datecreation ? dayjs(credentials.datecreation).fromNow() : 'No disponible'],
                ['Área', credentials.area],
                ['Servicio', credentials.servicio],
                ['Categoría', credentials.categoria],
                ['Tipo Cotización', credentials.tipocotizacion],
                ['Nombre Responsable', credentials.nombreresponsable],
                ['Cargo Responsable', credentials.cargoresponsable],
                ['Teléfono Responsable', credentials.telefonoresponsable],
                ['Email Responsable', credentials.emailresponsable],
              ].map(([label, value], index) => (
                <div className="div-perfil-detalle" key={index}>
                  <h5 className="equipo-detalle">{label}: </h5>
                  <p className="perfilequipo-text">{value || 'No disponible'}</p>
                </div>
              ))}
            </div>

            <div className="terminos-container-market">
              <hr className="clientes_separator" />
              <div className="div-perfil-detalle">
                <h5 className="equipo-detalle">Observaciones: </h5>
                <p className="perfilequipo-text">{credentials.observaciones || 'Sin observaciones'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className="div_cargando">
      <CircularProgress size={50} color="primary" className="login-progress" />
    </div>
  );

  let mapeoitems = !loadingdataasistencial ? (
    Array.isArray(credentials.items) && credentials.items.length > 0 ? (
      credentials.items.map((item, idx) => (
        <div key={idx} className="item-market-card">
          <div className='item-market-container'>
            {[
              ['Nombre', item.nombre],
              ['Marca', item.marca],
              ['Cantidad', item.cantidad],
              ['Descripción', item.descripcion],
            ].map(([label, value], index) => (
              <div className={label === 'Descripción' ? 'item-market-descripcion' : 'item-market-item'} key={index}>
                <h3 className="titulo-market-text">{label}</h3>
                <h5 className="item-market-text">{value || 'N/A'}</h5>
              </div>
            ))}
          </div>
        </div>
      ))
    ) : (
      <div className="item-market-card">
        <div className='item-market-container'>
          <div className='item-market-descripcion'>
            <h3 className="titulo-market-text">Añade un Item para Empezar</h3>
          </div>
        </div>
      </div>
    )
  ) : (
    <div className="div_cargando">
      <CircularProgress size={50} color="primary" className="login-progress" />
    </div>
  );

  return (
    <div>
      <div className="titulo_section">
        <div className="titulo_clientes">
          <h1 className="text-clientes">Solicitud de Compra</h1>
          <hr className="clientes_separator" />
        </div>

        <div className="div_boton">
          <Link to={`/dashboard/perfilcliente/${this.props.match.params.clienteId}`}>
            <MyButton tip="Volver">
              <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
            </MyButton>
          </Link>
        </div>
      </div>

      <div className='container_content_items'>{cargarSolicitud}</div>

      <div className="titulo_section">
        <div className="titulo_clientes">
          <h1 className="text-clientes">Items</h1>
          <hr className="clientes_separator" />
        </div>
        <div className="div_boton" />
      </div>

      <div>
        {mapeoitems}
        <div className='div-publicar-market' />
      </div>
    </div>
  );
}
}

SolicitudDetailCliente.propTypes = {
    
    getSolicitudCompra: PropTypes.func.isRequired,
    dataAsistencial:PropTypes.object.isRequired,
    clearErrors:PropTypes.func.isRequired,
    UI:PropTypes.object.isRequired,
    
  };

const mapActionsToProps={getSolicitudCompra,clearErrors};

const mapStateToProps = (state)=>({
    dataAsistencial:state.dataAsistencial,
    UI:state.UI
})



export default connect(mapStateToProps,mapActionsToProps)(SolicitudDetailCliente);
